exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-cell {\n  -webkit-user-select:text;\n  -moz-user-select:text;\n  -ms-user-select:text;\n  user-select:text;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1020/wa1020.component.css
// module id = ../../../../../src/app/pages/wa1Arrival/wa1020/wa1020.component.css
// module chunks = main